var fieldErrorReasons = ["Invalid zip code for mailing address"];
var getFieldErrorMessages = function (fieldErrors) {
    var _a;
    var fieldStrings = [];
    (_a = fieldErrors.errors) === null || _a === void 0 ? void 0 : _a.forEach(function (error) {
        var reason = error.reason;
        if (reason === fieldErrorReasons[0]) {
            fieldStrings.push("forms.errors.invalid_data.zipCode");
        }
    });
    return fieldStrings;
};
export default getFieldErrorMessages;
